import { css } from 'lit'

export const polarChartWrapperStyles = css`
    .polar-plot {
        padding: 20px;
        font-family: MaerskText;
        min-width: 1066px;
        overflow-x: scroll;
        width: fit-content;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .polar-modal-grid {
        display: flex;
    }

    .title-wrapper {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .title {
        font-size: 25px;
        line-height: 32px;
    }

    .heading {
        display: flex;
        gap: 5px;
        justify-content: space-between;
    }
    .heading-status-contents {
        display: flex;
        gap: 7px;
        align-items: center;
        height: min-content;
    }

    .description {
        font-size: 14px;
        line-height: 20px;
        margin: 0;
    }

    .polar-chart {
        height: 550px;
        width: 500px;
    }

    .bar-chart {
        width: 100%;
        max-width: 620px;
    }

    .charts-container {
        border: 1px solid #cfcfcf;
        border-radius: 6px;
        padding: 13px;
        display: flex;
        flex-direction: column;
        width: 625px;
    }

    .contents {
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .back-button {
        padding: 0;
        color: var(--neutrals-grey-02, black);
        background: none;
        border: none;
        outline: none;
        cursor: pointer;
        margin-top: 8px;
    }

    .back-button > svg {
        display: block;
        fill: currentColor;
    }

    .last-updated {
        font-size: 12px;
        line-height: 16px;
        color: var(--neutrals-grey-02, black);
        display: flex;
    }
    .color {
        color: green;
        padding-left: 3px;
    }

    .flex-grow {
        flex-grow: 1;
    }
`

export const polarChartFormStyles = css`
    mc-input::part(field),
    mc-input::part(input) {
        font-size: 14px;
        font-weight: 400;
        line-height: 0;
        height: 14px;
        text-align: left;
        box-sizing: content-box !important;
    }

    mc-input {
        font-size: 12px !important;
        --mds_brand_typography_text_small_desktop_font-size: 11px;
        --mds_brand_typography_text_small_desktop_line-height: 12px;
        box-sizing: content-box !important;
    }

    mc-input::part(field) {
        width: 150px;
        --mds_brand_typography_text_medium_mobile_font-size: 12px;
    }

    mc-input:not([readonly])::part(field),
    mc-input:not([readonly])::part(input) {
        background-color: var(--gray-input-background);
    }

    mc-button::part(button) {
        padding: 2px;
        font-size: 14px;
    }

    mc-tag::part(text-and-icon) {
        font-size: 9px;
        font-weight: 700;
        color: black;
    }

    mc-tag::part(tag) {
        padding: 0 6px;
        background-color: var(
            --mds_brand_appearance_warning_default_border-color
        );
        height: 15px;
    }

    .input-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 2px;
    }

    .input-container--error {
        align-items: flex-start;
    }

    .read-only-container {
        display: flex;
        flex-direction: row;
        width: 150px;
        line-height: 16px;
    }

    .read-only-container-value {
        font-size: 14px;
        padding-left: 11px;
    }

    .read-only-container-unit {
        font-size: 12px;
        color: #767676;
        margin-left: 5px;
        margin-right: 15px;
    }

    .form-container-section {
        margin-bottom: 28px;
    }

    .form-title {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 23px;
        display: flex;
        justify-content: space-between;
    }

    .form-label {
        color: var(--functional-grey-700);
        font-size: 12px;
        line-height: 16px;
    }

    .change-view-title {
        color: var(--functional-grey-700);
        font-size: 12px;
        line-height: 20px;
        margin-bottom: 6px;
    }

    .button-container {
        display: flex;
        align-content: center;
    }

    .margin-left-button {
        margin-left: 9px;
    }

    .margin-right-button {
        margin-right: 9px;
    }

    mc-button-group-item[selected]::part(button) {
        background-color: var(
            --mds_brand_appearance_secondary_default_background-color
        );
        color: white;
    }
    .version-info {
        color: #767676;
        padding-top: 10px;
        font-size: 11px;
    }
`
export const polarPlotChartStyles = css`
    .polar-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 39rem;
        height: 38rem;
    }

    #chartContainer {
        width: 450px;
        height: 450px;
        z-index: 4;
    }

    .chart-container {
        position: relative;
        width: 450px;
        height: 450px;
    }

    .svg {
        position: absolute;
        top: 50%;
        left: 50%;
        pointer-events: none;
        transform-origin: center;
        z-index: 5;
    }

    .circle-band {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 80%;
        height: 80%;
        border-radius: 50%;
        border: 35px solid rgba(245, 245, 245, 1);
        transform: translate(-50%, -50%);
        pointer-events: none;
        z-index: 2;
    }

    #icon-wrapper {
        position: absolute;
        transform: translate(-50%, -50%);
        z-index: 10;
    }

    .label {
        font-family: 'Maersk Text';
        position: absolute;
        font-size: 19px;
        font-weight: 500;
        transform: translate(-50%, -50%);
        z-index: 10;
    }

    .label.n {
        top: -4%;
        left: 50%;
        color: rgba(246, 0, 0, 1);
    }
    .label.s {
        bottom: -9%;
        left: 50%;
        color: rgba(118, 118, 118, 1);
    }
    .label.e {
        top: 50%;
        right: -6%;
        color: rgba(118, 118, 118, 1);
    }
    .label.w {
        top: 50%;
        left: -4%;
        color: rgba(118, 118, 118, 1);
    }

    .degree-line {
        position: absolute;
        width: 1px;
        height: 20%;
        top: 10%;
        background-color: red;
        opacity: 0.6;
        border-style: dashed;
        border-width: 1px;
        border-color: red;
        transform-origin: bottom center;
    }

    .north-dash {
        position: absolute;
        top: 49.7%;
        left: 50%;
        width: 33px;
        height: 3px;
        background-color: red;
        opacity: 1;
        z-index: 1;
        transform-origin: left;
    }

    .degree-dash {
        position: absolute;
        top: 49.7%;
        left: 50%;
        width: 33px;
        height: 2.5px;
        background-color: grey;
        opacity: 0.7;
        transform-origin: left;
    }

    .degree-dash-axis {
        position: absolute;
        top: 49.7%;
        left: 50%;
        width: 23px;
        height: 2.2px;
        background-color: grey;
        opacity: 0.4;
        transform-origin: left;
    }

    .degree-label {
        position: absolute;
        transform-origin: center center;
        font-size: 12px;
        text-align: center;
        z-index: 10;
        top: 216px;
        left: 216px;
        color: grey;
        font-family: 'Maersk Text';
    }

    .legend {
        font-family: 'Maersk Text';
        display: flex;
        color: grey;
        flex-direction: column;
        border-radius: 5px;
        z-index: 10;
        font-size: 12.5px;
    }

    .left-legend {
        position: absolute;
        left: -91px;
        top: -5%;
        transform: translateY(-50%);
        width: 230px;
    }

    .right-legend {
        position: absolute;
        right: -106px;
        top: -7%;
        transform: translateY(-50%);
        width: 170px;
    }

    .legend-heading {
        margin-bottom: 6px;
        line-height: 16px;
    }

    .legend-item {
        display: flex;
        align-items: center;
        min-height: 16px;
        margin-bottom: 4px;
        line-height: 16px;
    }

    .legend-checkbox {
        appearance: none;
        position: relative;
        box-sizing: border-box;
        flex: 0 0 16px;
        width: 16px;
        height: 16px;
        margin: 0 8px 0 0;
        border: 2px solid var(
            --mds_brand_appearance_secondary_default_background-color,
            #42b0d5
        );
        border-radius: 1px;
        background-color: #fff;
        cursor: pointer;
    }

    .legend-checkbox:checked::after {
        content: '';
        position: absolute;
        left: 4px;
        top: 0;
        width: 4px;
        height: 9px;
        border: solid var(
            --mds_brand_appearance_secondary_default_background-color,
            #42b0d5
        );
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

    .legend-checkbox:focus-visible {
        outline: 2px solid var(
            --mds_brand_appearance_secondary_default_background-color,
            #42b0d5
        );
        outline-offset: 2px;
    }

    .legend-checkbox-spacer {
        flex: 0 0 24px;
        width: 24px;
    }

    .legend-color {
        box-sizing: border-box;
        flex: 0 0 14px;
        width: 14px;
        height: 14px;
        margin-right: 8px;
        border-radius: 0;
    }

    .legend-line {
        width: 25px;
        height: 2px;
        margin-right: 8px;
    }

    .solid-line {
        background-color: rgba(2, 115, 173, 1);
    }

    .dashed-line {
        border-top: 3px dashed rgba(86, 130, 236, 1);
    }

    .weather-legend-item {
        margin-left: 2px;
    }

    .legend-weather-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 18px;
        margin-right: 8px;
    }

    .legend-weather-icon svg {
        display: block;
    }

    .custom-tooltip {
        position: relative;
        padding: 10px 20px 5px 10px;
        background-color: white;
        border: 1px solid var(--neutrals-grey-07);
        border-radius: 4px;
        font-family: 'Maersk Text';
        color: #545454;
        font-size: 10px;
        line-height: 14px;
        z-index: 100;
    }

    .tooltip-content {
        padding-bottom: 6px;
    }

    .wave-circle {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: rgba(134, 56, 229, 1);
    }

    .swell-circle {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: rgba(255, 172, 28, 1);
    }
    .echarts-tooltip,
    .echarts-tooltip div {
        box-shadow: none !important;
    }
`

export const polarPlotCartesianStyles = css`
    .adjustment-buttons-wrapper {
        display: flex;
        justify-content: space-between;
        item-align: center;
        margin-bottom: 28px;
    }
    .custom-tooltip {
        position: relative;
        padding: 10px 20px 5px 10px;
        background-color: white;
        border: 1px solid var(--neutrals-grey-07);
        border-radius: 4px;
        font-family: 'Maersk Text';
        color: #545454;
        font-size: 10px;
        line-height: 14px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    .tooltip-content {
        padding-bottom: 6px;
    }

    .tooltip-arrow {
        position: absolute;
        top: 50%;
        right: 100%; /* Position the arrow outside the left side of the tooltip */
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 8px solid white;
        border-left: none;
    }
`
